import { render, staticRenderFns } from "./CatalogSets.vue?vue&type=template&id=24cc4a15"
import script from "./CatalogSets.vue?vue&type=script&lang=js"
export * from "./CatalogSets.vue?vue&type=script&lang=js"
import style0 from "./CatalogSets.vue?vue&type=style&index=0&id=24cc4a15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports